import { ChangeDetectorRef, Component } from '@angular/core';
import { VideoGuidesService } from '../core/service/video-guides.service';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakStateService } from '../core/service/utility.service';
import { EnvironmentService } from "../core/service/environment.service";
import playbackVideos from '../../assets/videos/feature-videos.json';
import { Router } from '@angular/router';
import { UserManagementComponent } from '../features/user-management/user-management.component';
import { MatDialog } from '@angular/material/dialog';




interface VideoItem {

  playbackId: string;
  playbackToken: string | null;
  title?: string;
}

@Component({
  selector: 'app-guide',
  templateUrl: './guide.component.html',
  styleUrls: ['./guide.component.scss']
})
export class GuideComponent {
    playbackId : string | null = null;
    playbackToken: string | null = null;
      userHasAccess = false;
    isLoggedIn = false;

      videos: VideoItem[] = playbackVideos.playbackVideos;

  constructor(private videoGuidesService: VideoGuidesService,private cdr: ChangeDetectorRef,    private keycloakService: KeycloakService,   
      private keycloakStateService: KeycloakStateService,  public environmentService: EnvironmentService, private router: Router, private dialog: MatDialog,) {}



  async ngOnInit() {


    try {
            this.isLoggedIn = await this.keycloakService.isLoggedIn();

  if (this.isLoggedIn) {
    const token = await this.keycloakService.getToken();
    const decoded: any = JSON.parse(atob(token.split('.')[1]));

  }

  console.log("plybck videos:",playbackVideos);

    this.keycloakStateService.observeRealmRoles().subscribe(roles => {
    this.userHasAccess = roles.some(role => role.toLowerCase() === 'ztaas_admin');
  });

    this.videos.forEach((video, index) => {
      this.videoGuidesService.getPlaybackToken(video.playbackId).subscribe(
        (response) => {
          this.videos[index].playbackToken = response.token;
          this.cdr.detectChanges();
        }
      );
    });

    } catch (error) {
      
    }

  }


    
    
      goToVideoGuides() {
        this.router.navigate(['/guide']);
      }
    
      
     async logout(): Promise<void> {
    
        try {
    
          // Refresh token before logout
          try {
            await this.keycloakService.updateToken(30);
          } catch (refreshError) {
            console.warn(
              'Token refresh failed before logout',
              refreshError
            );
          }
    
          const kc =
            this.keycloakService.getKeycloakInstance();
    
          // Prevent invalid id_token_hint=undefined
          if (!kc.idToken) {
    
            console.warn(
              'No idToken available. Redirecting manually.'
            );
    
            window.location.href = window.location.origin;
    
            return;
          }
    
          await this.keycloakService.logout(
            window.location.origin
          );
    
        } catch (error) {
    
          console.error('Logout failed', error);
    
          window.location.href = window.location.origin;
        }
      }
    
      openUserManagement() {
        if (this.userHasAccess) {
          this.dialog.open(UserManagementComponent, { width: '1000px', height: '700px' });
        } else {
          alert('Unauthorized');
        }
      }


}
